import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { RxCross2 } from "react-icons/rx";
import { ImSpinner } from "react-icons/im";
import { fetchData } from "../../GlobalFunctions";

const Prompt = ({
  showUserInstructions,
  userInstructions,
  setUserInstructions,
  userInstructionsActive,
  setUserInstructionsName,
}: any) => {
  interface PromptData {
    id: string;
    prompt_name: string;
    instruction: string;
  }

  const [name, setName] = useState("");
  const [description, setDescription] = useState<string>("");
  const [currentIndex, setCurrentIndex] = useState<number>(-1);

  const [promptData, setPromptData] = useState<PromptData[] | null>(null);
  const [selectedInstruction, setInstruction] =
    useState<string>(userInstructions);

  const [searchQuery, setSearchQuery] = useState<string>("");

  useEffect(() => {
    if (userInstructionsActive) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [userInstructionsActive]);

  const handleChildClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  useEffect(() => {
    fetchData(`${process.env.REACT_APP_AVAILABLE_PROMPT}`, setPromptData);
  }, []);

  useEffect(() => {
    if (currentIndex !== -1) {
      setName(promptData ? promptData[currentIndex].prompt_name : "");
      setDescription(promptData ? promptData[currentIndex].instruction : "");
    } else {
      setName("");
      setDescription("");
    }
  }, [currentIndex]);

  return (
    <AnimatePresence>
      <motion.div
        onClick={showUserInstructions}
        initial={{ opacity: 0, x: -1 }}
        whileInView={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -1 }}
        viewport={{ once: false }}
        transition={{ duration: 0.7 }}
        className={
          userInstructionsActive
            ? " fixed inset-0 flex items-center justify-center z-50 backdrop-blur-md"
            : "hidden"
        }
      >
        <div
          className=" bg-[#EDEAF8] rounded-lg shadow-2xl"
          onClick={handleChildClick}
        >
          <div className=" md:w-[750px] w-[350px]">
            <div className=" flex flex-col ">
              <div className="relative flex flex-row items-center justify-between p-4">
                <button
                  onClick={showUserInstructions}
                  className="text-[25px] bg-[#4D30B5] hover:bg-[#1b1436] duration-300 rounded-lg p-1 text-white absolute top-2 right-2"
                >
                  <RxCross2 size={25} className="-mt-[1px]" />
                </button>
              </div>
            </div>
            <div className=" p-4">
              <div className="flex flex-col">
                <div className="flex flex-col gap-4">
                  <h1 className="text-center text-[25px] font-bold">
                    Available Business Rule
                  </h1>
                  <input
                    type="text"
                    placeholder="Search by business rule name..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="border-[2px] text-black outline-none p-2 rounded-lg w-full"
                  />
                  <div className="h-[300px] overflow-auto">
                    <div className="grid lg:grid-cols-2 gap-4">
                      {promptData ? (
                        promptData
                          .slice()
                          .reverse()
                          .filter((instruction) =>
                            instruction.prompt_name
                              .toLowerCase()
                              .includes(searchQuery.toLowerCase())
                          )
                          .map((instruction) => (
                            <div
                              key={instruction.id}
                              className={`border p-4 rounded-lg cursor-pointer hover:shadow-lg duration-300 relative ${
                                userInstructions === instruction.id
                                  ? "bg-blue-100"
                                  : "bg-white"
                              }`}
                              onClick={() => {
                                if (userInstructions === instruction.id) {
                                  setUserInstructions("");
                                  setInstruction("");
                                  setUserInstructionsName("");
                                  setCurrentIndex(-1);
                                } else {
                                  setUserInstructions(instruction.id);
                                  setInstruction(instruction.id);
                                  setUserInstructionsName(
                                    instruction.prompt_name
                                  );
                                  setCurrentIndex(
                                    promptData.findIndex(
                                      (item) => item.id === instruction.id
                                    ) ?? -1
                                  );
                                }
                              }}
                            >
                              <h3 className="text-lg font-semibold">
                                {instruction.prompt_name}
                              </h3>
                              <p className="text-gray-600">
                                {instruction.instruction}
                              </p>
                            </div>
                          ))
                      ) : (
                        <div className="animate-spin flex justify-center">
                          <ImSpinner size={30} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default Prompt;
